import { Flex, Table } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import { CustomTitle } from '../../../../components';

interface SWminimumTimeRow {
  service: string;
  us_domestic: string;
  international: string;
}

interface SWminimumTimeProps {
  data?: {
    columns?: string[]; // ["Service", "US Domestic", "International"]
    rows?: SWminimumTimeRow[];
  };
}

const COLUMN_KEY_MAP: Record<string, keyof SWminimumTimeRow> = {
  Service: 'service',
  'US Domestic': 'us_domestic',
  International: 'international',
};

const SWminimumTime: React.FC<SWminimumTimeProps> = ({ data }) => {
  if (!data?.rows || data.rows.length === 0 || !data.columns) {
    return (
      <Flex justify='center' className='disabled-row'>
        No data available
      </Flex>
    );
  }

  // Build columns dynamically from backend
  const columns: ColumnsType = data.columns.map((col) => ({
    title: col,
    dataIndex: COLUMN_KEY_MAP[col],
    key: COLUMN_KEY_MAP[col],
  }));

  // Add AntD required "key"
  const dataSource = data.rows.map((row, index) => ({
    key: String(index + 1),
    ...row,
  }));

  return (
    <div className='bg-white shadow rounded-lg'>
      <CustomTitle
        text='Minimum times'
        fontSize='16px'
        fontWeight='600'
        lineHeight='20px'
        color='var(--text-primary)'
        marginBottom='20px'
      />

      <Table
        className='zl-custom-times-table'
        dataSource={dataSource}
        columns={columns}
        pagination={false}
        rowHoverable={false}
        bordered
      />
    </div>
  );
};

export default SWminimumTime;
